import SharedConnect from "./socket.shared-conn"
import shortid from 'shortid'

/* 连接成功 */
const ON_CONNECT = "on-connect"
/* 连接错误 */
const ON_CONNECT_ERROR = "on-connect-error"
/* 连接关闭 */
const ON_CONNECT_CLOSED = "on-connect-closed"
/* 订阅主题消息推送 */
const ON_SUBSCRIBE_RECV = "on-subscribe-recv"
/* 订阅主题应答 */
const ON_SUBSCRIBE_ACK = "on-subscribe-ack"
/* 取消订阅应答 */
const ON_CANCEL_SUBSCRIBE_ACK = "on-cancel-subscribe-ack"

const SUB_MAP_STORAGE_KEY = "ws-subMap"

const HSocket = function (user, url, appData) {
  if (!user || !url) {
    throw new Error('Make sure that user and url are both valid!')
  }

  this.eventHub = {
    [ON_CONNECT]: null,
    [ON_CONNECT_ERROR]: null,
    [ON_CONNECT_CLOSED]: null,
    [ON_SUBSCRIBE_RECV]: null,
    [ON_SUBSCRIBE_ACK]: null,
    [ON_CANCEL_SUBSCRIBE_ACK]: null
  }
  // 获取唯一订阅者
  this.subscriber = this.getSubscriber(user)
  this.sharedConnect = new SharedConnect(this.subscriber)
  this.url = url
  this.appData = appData

  // 检测连接状态
  this.sharedConnect.testConnect()
  this.sharedConnect.worker.port.addEventListener(
    "message",
    e => {
      this.handleWorkerMessage.call(this, e)
    }
  )
}

// 连接
HSocket.prototype.connect = function () {
  if (this.url) {
    this.sharedConnect.connect(this.url)
  }
}

// 关闭连接
HSocket.prototype.closeConn = function () {
  this.sharedConnect.closeConn()
}

/**
 * 订阅主题
 */
HSocket.prototype.subscribe = function (params = {}) {
  let subParams = this.makeParams({
    /* 0是请求，1是应答 */
    messageType: 0,
    /* 620001订阅，620002取消订阅，620003推送 */
    function: '620001',
    appData: this.appData,
    subscriberName: this.subscriber,
    ...params
  })
  this.sharedConnect.subscribe(subParams)
}

// 退订
HSocket.prototype.cancelSub = function (params = {}) {
  let cancelSubParams = this.makeParams({
    /* 0是请求，1是应答 */
    messageType: 2,
    /* 620001订阅，620002取消订阅，620003推送 */
    function: '620002',
    appData: this.appData,
    subscriberName: this.subscriber,
    ...params
  })
  this.sharedConnect.cancelSub(cancelSubParams)
}

// 销毁资源
HSocket.prototype.destroy = function () {
  this.sharedConnect.worker.port.removeEventListener(
    "message",
    e => {
      this.handleWorkerMessage.call(this, e)
    }
  );
  this.sharedConnect.destroy()
  this.sharedConnect = null
  this.eventHub = null
}

// 绑定监听事件回调函数
HSocket.prototype.on = function (eventName, cb) {
  const eventHub = this.eventHub
  if (eventHub.hasOwnProperty(eventName)) {
    eventHub[eventName] = cb
  }
}

HSocket.prototype.emit = function (eventName, data) {
  const eventHub = this.eventHub
  const cb = eventHub && eventHub[eventName]
  if (typeof cb === 'function') {
    cb(data)
  }
}

HSocket.prototype.handleWorkerMessage = function (e) {
  const evt = e.data
  let data = evt.data
  switch (evt.type) {
    /* 连接成功 */
    case "connect-success":
      this.emit(ON_CONNECT)
      break
    /* 连接失败 */
    case "connect-error":
      this.emit(ON_CONNECT_ERROR)
      break;
    /* 连接关闭 */
    case "connect-closed":
      this.emit(ON_CONNECT_CLOSED)
      break
    case "subscribe-ack":
      data = data ? JSON.parse(data) : {}
      if (data.appData === this.appData || !data.appData || !this.appData) {
        this.emit(ON_SUBSCRIBE_ACK, data)
      }
      break
    case "cancel-subscribe-ack":
      data = data ? JSON.parse(data) : {}
      if (data.appData === this.appData || !data.appData || !this.appData) {
        this.emit(ON_CANCEL_SUBSCRIBE_ACK, data)
      }
      break
    case "testConnect":
      if (typeof evt.data === 'boolean' && evt.data) {
        this.emit(ON_CONNECT)
      }
      break;
    /* 收到订阅主题消息推送 */
    case "subscribe-recv":
      this.handleSubRecv(evt.data)
      break
  }
}

/**
 * 获取全局唯一的订阅者名称
 */
HSocket.prototype.getSubscriber = function (user) {
  let subscriber
  try {
    // ws-subMap存放用户名-唯一id映射关系
    let subMapStr = window.localStorage.getItem(SUB_MAP_STORAGE_KEY)
    let subscriberMap
    if (!subMapStr) {
      subscriberMap = {}
    } else {
      subscriberMap = JSON.parse(subMapStr)
    }
    // 优先从localstorage中取，没有则新建
    if (!subscriberMap.hasOwnProperty(user)) {
      subscriberMap[user] = `${user}@${shortid.generate()}`.substring(0, 32)
      window.localStorage.setItem(SUB_MAP_STORAGE_KEY, JSON.stringify(subscriberMap))
    }
    subscriber = subscriberMap[user]
  } catch (e) {
    subscriber = `_TEMP_USER_@${shortid.generate()}`
  }
  return subscriber
}

HSocket.prototype.assertParams = function (params = {}) {
  ['messageType', 'function', 'subscriberName', 'topicName', 'appData'].forEach(field => {
    let val = params[field]
    if (val === '' || typeof val === 'undefined' || val === null) {
      throw new Error(`Param '${field}' should not be undefined, null or empty string.`)
    }
  })
}

HSocket.prototype.makeParams = function (params = {}) {
  this.assertParams(params)
  let defaultParams = {
    filter: {},
    replace: false,
    rebuild: false,
    returnFiled: '',
    bizCheck: {}
  }
  return Object.assign(defaultParams, params)
}

HSocket.prototype.handleSubRecv = function (data) {
  if (data.appData === this.appData || !data.appData || !this.appData) {
    this.emit(ON_SUBSCRIBE_RECV, data)
  }
}

export default HSocket